import axios from 'src/utils/axios';

import NotificacoesService from 'src/services/notificacoesService';

export const GET_NOTIFICATIONS = '@notifications/get-notifications';

export function getNotifications() {
  const request = NotificacoesService.getBell();
  
  return (dispatch) => {
    request.then((response) => {      
      dispatch({type: GET_NOTIFICATIONS,payload: response.data})    
    })
  };
}
